const stateDefault = {
  payload: {}
};

export default (state = stateDefault, action) => {   
  switch (action.type){
    case 'REGISTER_TWOOCA_INPUT':
      return {
        ...state,
        payload: action.payload,
      };
    default:
      return state;
  }
};
